module.exports = __webpack_public_path__ + "media/images/landing/persons/jan-uhlar-d50e4e3ba67c32a31221f6714f176229.jpg";